import { render, staticRenderFns } from "./pay-success.vue?vue&type=template&id=f55d921c&scoped=true&"
import script from "./pay-success.vue?vue&type=script&lang=js&"
export * from "./pay-success.vue?vue&type=script&lang=js&"
import style0 from "./pay-success.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pay-success.vue?vue&type=style&index=1&id=f55d921c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55d921c",
  null
  
)

export default component.exports